import React from "react";
import "./list.scss";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import Datatable from "../../components/Datatable";
const List = ({ type }) => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <Datatable type={type} />
      </div>
    </div>
  );
};

export default List;
